<template>
    <div class="items-group-header">
        <v-row no-gutters align="center">
            <v-col cols="auto" class="items-group-header__line"></v-col>
            <v-col cols="auto">
                <div class="items-group-header__text">
                    {{ format(_modelValue, 'eeee, d MMMM, yyyy', options) }}
                </div>
            </v-col>
            <v-col cols="auto" class="items-group-header__line"></v-col>
        </v-row>
    </div>
</template>

<script setup lang="ts">
import { parseISO, format } from 'date-fns';
import { enUS, nb } from 'date-fns/locale';
import { useI18n } from 'vue-i18n';

interface Props {
    modelValue: Date | string | number;
}

const { locale } = useI18n();
const props = defineProps<Props>();
const _modelValue = parseISO(props.modelValue as string);
const options = { locale: locale.value == 'no' ? nb : enUS };
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'vuetify/lib/styles/tools/index' as tools;

.items-group-header {
    &__text {
        $-font-size: tools.map-deep-get($typography, 'body-1', 'size');
        $-font-weight: tools.map-deep-get($typography, 'body-1', 'weight');
        $-letter-spacing: tools.map-deep-get($typography, 'body-1', 'letter-spacing');
        $-line-height: tools.map-deep-get($typography, 'body-1', 'line-height');
        $-text-transform: tools.map-deep-get($typography, 'body-1', 'text-transform');

        padding: ($spacer * 4) ($spacer * 3);
        @include tools.typography($-font-size, $-font-weight, $-letter-spacing, $-line-height, $-text-transform);

        &::first-letter {
            text-transform: capitalize;
        }
    }

    &__line {
        height: 1px;
        border: 1px solid var(--v-color-black);
        flex-grow: 1;
    }
}
</style>
